var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('div',[_c('selected-article-info'),(_vm.selected_article)?_c('chart-card'):_c('div',{staticClass:"text-with-icon m-t-50 m-b-50"},[_c('i',{staticClass:"icon-search"}),_vm._v(" Seleccione un articulo para ver sus rendimientos ")])],1):_c('div',{staticClass:"all-center"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }